// Fuente única de verdad de las extensiones que acepta la herramienta "Cargar
// Capas". El atributo accept del input y la validacion de la selección salen de
// aca para que el explorador de archivos no ofrezca formatos que el importador
// después rechaza (QA-184).

// Formatos que se pueden cargar por sí solos: cada uno tiene su rama en
// parseImportedFile()/inspectImportedFile() de importedFileParser.js.
export const IMPORT_FORMAT_EXTENSIONS = Object.freeze([
  ".zip",
  ".shp",
  ".kmz",
  ".kml",
  ".gpx",
  ".geojson",
  ".json",
  ".parquet",
]);

// Acompañantes de un shapefile: solos no son una capa, pero se aceptan en la
// selección múltiple porque ahi se empaquetan junto al .shp en un ZIP.
export const SHAPEFILE_SIDECAR_EXTENSIONS = Object.freeze([
  ".shx",
  ".dbf",
  ".prj",
  ".cpg",
]);

export const IMPORT_ACCEPT = [
  ...IMPORT_FORMAT_EXTENSIONS,
  ...SHAPEFILE_SIDECAR_EXTENSIONS,
].join(",");

const SELECTABLE_EXTENSIONS = new Set([
  ...IMPORT_FORMAT_EXTENSIONS,
  ...SHAPEFILE_SIDECAR_EXTENSIONS,
]);

const FORMAT_LIST = "SHP (o su ZIP), KMZ, KML, GPX, GeoJSON y Parquet";

export const extensionOf = name =>
  (String(name || "").toLowerCase().match(/\.[^.\/]+$/) || [""])[0];

const unique = values => Array.from(new Set(values));

/**
 * Revisa una selección de archivos antes de intentar leerla.
 * @param {string[]} names nombres de los archivos seleccionados
 * @returns {string|null} mensaje para el usuario, o null si la selección sirve
 */
export function importSelectionError(names) {
  const selection = (Array.isArray(names) ? names : []).filter(Boolean);
  if (!selection.length) return null;

  const unsupported = unique(
    selection
      .filter(name => !SELECTABLE_EXTENSIONS.has(extensionOf(name)))
      .map(name => extensionOf(name) || `«${name}»`)
  );
  if (unsupported.length) {
    return `Formato no soportado: ${unsupported.join(", ")}. Solo se aceptan archivos ${FORMAT_LIST}.`;
  }

  const hasShapefile = selection.some(name => extensionOf(name) === ".shp");

  if (selection.length === 1) {
    const extension = extensionOf(selection[0]);
    if (SHAPEFILE_SIDECAR_EXTENSIONS.includes(extension)) {
      return `Un archivo ${extension} no se puede cargar solo: selecciona también el .shp que lo acompaña, o sube el shapefile completo en un .zip.`;
    }
    return null;
  }

  if (!hasShapefile) {
    return "La selección múltiple debe incluir al menos un archivo .shp.";
  }

  return null;
}
